<template>
  <div class="smart-traffic">
    <tabs :list="tablist" v-model="sel"></tabs>
    <div class="main">
      <mobi v-if="sel === 0"></mobi><sid v-if="sel === 1"></sid>
    </div>
    <ourserviceBtnVue/>
  </div>
</template>

<script>
import mobi from "./system.vue";
import sid from "./piles.vue";
import tabs from "/src/components/tabs/index.vue";
import ourserviceBtnVue from "../../../components/service/ourservice-btn.vue";
export default {
  components: { mobi, sid, tabs ,ourserviceBtnVue},
  data() {
    return {
      sel: 0,
      tablist: [
        {
          title: "EV Operating System",
          context:
            "Operating Platform, Multiple Vendors, Multiple Operators, IOS Android Application",
        },
        {
          title: "Charging Piles ",
          context:
            "Charging Pile, Single Phase AC, Single Gun DC, Double Gun DC",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.smart-traffic {
  display: flex;
  width: 100%;
  height: 100%;
  background: url("../../../assets/img/green_energy_ev.png") center center;
  background-size: cover;
  .main {
    flex: 1;
    height: 100%;
  }
  .height-light {
    width: 100%;
    height: 18.75px;
    background: rgba(249, 0, 0, 0.3);
  }

  
}
</style>
